import { defineMessages } from 'react-intl'

export default defineMessages({
  shippingInfo: {
    defaultMessage: 'Shipping Info'
  },
  returnsPaidBy: {
    defaultMessage: 'Returns Paid by:'
  },
  returnsInitiated: {
    defaultMessage: 'Returns must be initiated within:'
  },
  returnsRules: {
    defaultMessage: 'Returns Rules:'
  },
  seller: {
    defaultMessage: 'Seller'
  },
  buyer: {
    defaultMessage: 'Buyer'
  },
  domesticReturns: {
    defaultMessage: 'Domestic returns'
  },
  internationalReturns: {
    defaultMessage: 'International returns'
  },
  domesticShipping: {
    defaultMessage: 'Domestic'
  },
  internationalShipping: {
    defaultMessage: 'International'
  },
  ownShipping: {
    defaultMessage: 'Own Shipping'
  },
  integratedShipping: {
    defaultMessage: 'Shipping'
  }
})
